import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import { timeDurationToTime } from "../../utilities/utility";
import { NotificationManager } from "react-notifications";

export const DimSchedule = (props) => {

  const classes = useStyles();
  const [dimScheduleData, setDimScheduleData] = useState([]);

  useEffect(async () => {
    if (props.dimSchedule["sch_list"] != undefined) {
      setDimScheduleData(props.dimSchedule["sch_list"]);
    }
  }, [props.dimSchedule]);

  const getDimScheduleColumnList = () => {
    return [
      {
        title: "Start Time",
        // field: "onTime",
        render: ({ on_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        },
        exportTransformer: ({ on_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        }
      },
      {
        title: "End Time",
        // render: ({ off_time: {hrs:hrs=0,mins:mins=0} = {hrs:hrs=0,mins:mins=0} }) => {
        render: (data) => {
          let time = null;
          if (data["off_time"] != undefined) {
            time = data["off_time"];
          }
          return timeDurationToTime(time);
        },
        exportTransformer: ({ off_time: { hrs: hrs = 0, mins: mins = 0 } = { hrs: hrs = 0, mins: mins = 0 } }) => {
          return timeDurationToTime({ hrs: hrs, mins: mins });
        }
      },
      {
        title: "DIM PERCENTAGE",
        render: ({ dp: dp = 0 }) => {
          return dp;
        },
        exportTransformer: ({ dp: dp = 0 }) => {
          return dp;
        },
      }
    ];
  };

  return (
    <div className="dim-schedule">
      <MaterialTable
        style={{
          // margin: "20px 0",
          width: "100%",
        }}
        className={classes.table}
        title={<div className="title">Dim Schedule</div>}
        columns={getDimScheduleColumnList()}
        data={dimScheduleData}
        options={{
          exportButton: false,
          // grouping: true,
          search: false,
          selection: false,
          sorting: true,
          pageSize: 5,
          headerStyle: {
            backgroundColor: "#0071CE",
            color: "#FFF",
            fontSize: "0.9em",
            textAlign: "center",
          },
          actionsColumnIndex: -1,
          emptyRowsWhenPaging: false,
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: 'Edit Dim Schedule',
            onClick: (event, rowData) => {
              console.log(`Onclick Edit ${JSON.stringify(rowData)}`);
              props.OnClickEditDimSchedule(rowData);
            }
          },
          {
            icon: 'delete',
            tooltip: 'Delete Dim Schedule',
            onClick: (event, rowData) => {
              console.log(`Onclick delete ${JSON.stringify(rowData)}`);
              props.OnClickDeleteDimSchedule(rowData);
            }
          },
          props.isUpdated != null && {
            icon: 'save',
            tooltip: 'Save Dim Schedule',
            isFreeAction: true,
            onClick: (event) => {
              console.log("Onclick Save");
              if (props.isUpdated) {
                props.OnClickSaveDimSchedule(props.enableStatus);
              } else {
                NotificationManager.error("No chnages to save Dim Schedule", "", 3000);
              }
            }
          },
          {
            icon: 'add',
            tooltip: 'Add Dim Schedule',
            isFreeAction: true,
            onClick: (event) => {
              console.log("Onclick add");
              props.OnClickAddDimSchedule();
            }
          }
        ]}
      />

      {/* <MaterialTable
              style={{
                // margin: "20px 0",
                width: "100%",
              }}
              className={classes.table}
              title={<div className="title">Schedule Change History</div>}
              columns={getScheduleHistoryColumnList()}
              data={scheduleHistoryData}
              options={{
                exportButton: false,
                // grouping: true,
                search: false,
                selection: false,
                sorting: true,
                pageSize: 5,
                headerStyle: {
                  backgroundColor: "#0071CE",
                  color: "#FFF",
                  fontSize: "0.9em",
                  textAlign: "center",
                },
                actionsColumnIndex: -1,
                emptyRowsWhenPaging: false,
              }}
            /> */}
    </div>
  );
}

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);